import { useAlova } from '@/composables/use-alova'
import { useActivityObserver } from '@/composables/use-activity-observer'
import { ApiService } from '@/services/api-service'

export default {
  install: (app) => {
    const allAlovas = useAlova()
    app.provide('jsonApi', allAlovas.json)
    app.provide('blobApi', allAlovas.blob)
    app.provide('formApi', allAlovas.form)
    app.provide(
      'apiService',
      new ApiService({
        jsonApi: allAlovas.json,
        blobApi: allAlovas.blob,
        formApi: allAlovas.form,
      })
    )
    app.provide('userActivityObserver', useActivityObserver())
  },
}
